/**
穿梭框组件
*/
<template>
  <el-row class="components-my-transfer clearfix">
    <el-col :span="10" class="my-transfer-table">
      <div class="transfer-title-l pan-padding-side">可选列表</div>
      <div class="my-transfer-l-search pan-padding-side">
        <el-input
          size="mini"
          prefix-icon="el-icon-search"
          v-model="searchText"
          @keyup.enter.native="search"
          :placeholder="placeholder || '请输入关键字'"
        />
      </div>
      <div class="my-transfer-l-main">
        <el-table
          ref="table1"
          stripe
          :data="tempTableData"
          @selection-change="handleSelectionChange"
          height="238px"
          class="transfer-table"
        >
          <el-table-column type="selection" width="50" :selectable="selectFunLeft"></el-table-column>
          <el-table-column
            v-for="(item, index) in options.colOptions"
            :key="index"
            :prop="item.key"
            :label="item.label"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <div class="pan-padding-side">
        <slot></slot>
      </div>
    </el-col>
    <el-col :span="4" class="my-transfer-btn">
      <div>
        <i
          class="el-icon-arrow-left my-transfer-btn-item"
          :class="{active: hasSelect2.length}"
          @click="addToLeft"
        ></i>
        <i
          class="el-icon-arrow-right my-transfer-btn-item"
          :class="{active: hasSelect1.length}"
          @click="addToRight"
        ></i>
      </div>
    </el-col>
    <el-col :span="10" class="my-transfer-table">
      <div class="transfer-title-l pan-padding-side">
        已选列表
        <span
          class="gray fontsize-12"
          v-show="selectTableData.length"
        >(已选数量 {{selectTableData.length}})</span>
      </div>
      <div class="my-transfer-l-search pan-padding-side">
        <el-input
          size="mini"
          prefix-icon="el-icon-search"
          v-model="searchText2"
          :placeholder="placeholder || '请输入关键字'"
        />
      </div>
      <div class="my-transfer-l-main">
        <el-table
          ref="table2"
          stripe
          :data="searchText2 ? selectTableData_filter : selectTableData"
          @selection-change="handleSelectionChange2"
          height="290px"
          class="transfer-table"
        >
          <el-table-column type="selection" width="50" :selectable="selectFuRight"></el-table-column>
          <el-table-column
            v-for="(item, index) in options.colOptions"
            :key="index"
            :prop="item.key"
            :label="item.label"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <div class="pan-padding-side">&nbsp;</div>
    </el-col>
  </el-row>
</template>
<script>
let fn = () => {
  return true;
};
export default {
  name: "my-transfer",
  props: {
    rightSearchKey: {
      type: String,
      default: "name",
    },
    data: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    selectFunLeft: {
      type: Function,
    },
    selectFuRight: {
      type: Function,
    },
    placeholder: String,
    show: Boolean,
    // 可配置关键字和表格显示
    options: {
      type: Object,
      default: () => {
        return {
          key: "id",
          colOptions: [
            {
              label: "姓名",
              key: "name",
            },
            {
              label: "用户账号",
              key: "username",
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      searchText: "",
      searchText2: "",
      tableData: [],
      selectTableData: [],
      hasSelect1: [],
      hasSelect2: [],
      timer: null,
    };
  },
  created() {
    this.searchText = "";
    this.hasSelect1 = [];
    this.hasSelect2 = [];
    this.selectTableData = this.value || [];
    this.tableData = [...this.data];
  },
  computed: {
    tempTableData() {
      let list = [];
      this.tableData.forEach((item) => {
        let data = this.selectTableData.find(
          (v) => v[this.options.key] === item[this.options.key]
        );
        if (!data) {
          list.push(item);
        }
      });
      return list;
    },
    selectTableData_filter() {
      let list = [];
      this.selectTableData.forEach((item) => {
        if (
          item[this.rightSearchKey].includes(this.searchText2) ||
          (item.username && item.username.includes(this.searchText2))
        ) {
          list.push(item);
        }
      });
      return list;
    },
  },
  methods: {
    /**
     * 点击搜索
     */
    search() {
      this.$emit("search", this.searchText);
    },
    /**
     * 左侧表格选中变化事件
     * @param rows
     */
    handleSelectionChange(rows) {
      this.hasSelect1 = rows;
    },
    /**
     * 右侧侧表格选中变化事件
     * @param rows
     */
    handleSelectionChange2(rows) {
      this.hasSelect2 = rows;
    },
    /**
     * 加入到左侧
     */
    addToLeft() {
      if (!this.hasSelect2.length) {
        return;
      }
      let list = [];
      this.selectTableData.forEach((item) => {
        let index = this.hasSelect2.findIndex((v) => {
          return v[this.options.key] === item[this.options.key];
        });
        if (index < 0) {
          list.push(item);
        }
      });
      this.$emit("add-left", [...this.hasSelect2]);
      this.selectTableData = list;
      this.hasSelect2 = [];
      this.hasSelect1 = [];
      this.$refs.table1.clearSelection();
      this.$refs.table2.clearSelection();
    },
    /**
     * 加入到右侧
     */
    addToRight() {
      if (!this.hasSelect1.length) {
        return;
      }
      let list = [];
      this.hasSelect1.forEach((item) => {
        let index = this.selectTableData.findIndex((v) => {
          return v[this.options.key] === item[this.options.key];
        });
        if (index < 0) {
          list.push(item);
        }
      });
      this.$emit("add-right", [...this.hasSelect1]);
      this.selectTableData = [...this.selectTableData, ...list];
      this.$refs.table1.clearSelection();
      this.hasSelect1 = [];
    },
    handleSearch(val) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.search();
        clearTimeout(this.timer);
        this.timer = null;
      }, 600);
    },
  },
  watch: {
    data() {
      this.tableData = [...this.data];
    },
    searchText() {
      this.handleSearch();
    },
    selectTableData(val) {
      this.$emit("input", val);
    },
    value(val) {
      console.log(val);
      this.selectTableData = val;
    },
    show() {
      this.searchText = "";
      this.hasSelect1 = [];
      this.hasSelect2 = [];
      this.selectTableData = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.components-my-transfer {
  min-width: 700px;
}

.my-transfer-table {
  height: 100%;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;

  .transfer-title-l {
    height: 30px;
    line-height: 30px;
    background: #f5f7fa;
  }

  .my-transfer-l-search {
    padding-top: 5px;
    height: 30px;
  }

  .my-transfer-l-main {
    display: block;
    padding: 10px 5px;
  }

  .my-transfer-l-bottom {
    height: 30px;
  }
}

.my-transfer-btn {
  height: 100%;
  padding-top: 100px;

  .my-transfer-btn-item {
    display: block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border: 1px solid $gray;
    border-radius: 50%;
    margin: 10px auto;
    transition: all $transition-time;
    text-align: center;
    cursor: pointer;

    &.active {
      color: $primary;
      border-color: $primary;
    }
  }
}

.pan-padding-side {
  padding: 0 10px;
}
</style>
<style lang="scss">
.components-my-transfer {
  .my-transfer-l-main {
    .el-table td,
    .el-table th {
      height: 34px;
      padding: 0;
    }

    .el-table th {
      background-color: #e2f0e3;
      color: $primary;
      font-weight: normal;
      border-color: white;
    }
  }
}
</style>